import { useState, type FormEvent } from "react";
import { ArrowUpRight } from "lucide-react";
import { instagramCardTarget, navigateToSocialCard } from "./social-profile-entry";
import "./SocialProfileEntry.css";

export function SocialProfileEntry() {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  function preview(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    try {
      const target = instagramCardTarget(value);
      setError("");
      navigateToSocialCard(target);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "The profile link could not be opened.");
    }
  }

  return (
    <section id="start" className="social-entry" aria-labelledby="social-entry-title">
      <span className="social-entry-at" aria-hidden="true">@</span>
      <div className="social-entry-content">
        <h2 id="social-entry-title">Your profile.<br />Your card.</h2>
        <p className="social-entry-intro">Start with your Instagram. Keep your photos, your bio, your identity.</p>
        <form aria-label="Preview your profile" onSubmit={preview} noValidate>
          <label htmlFor="social-profile">Instagram handle or profile link</label>
          <div className="social-entry-field">
            <input
              id="social-profile" name="profile" type="text" value={value}
              onChange={(event) => { setValue(event.target.value); setError(""); }}
              placeholder="@your.handle" autoComplete="username" autoCapitalize="none"
              spellCheck={false} maxLength={256} aria-invalid={!!error}
              aria-describedby={error ? "social-entry-error social-entry-help" : "social-entry-help"}
            />
            <button type="submit">Preview your card <ArrowUpRight size={20} aria-hidden="true" /></button>
          </div>
          {error && <p id="social-entry-error" className="social-entry-error" role="alert">{error}</p>}
        </form>
        <p id="social-entry-help" className="social-entry-help">Preview first. Open Manage on your card to connect Passkey and verify your bio.</p>
        <details className="social-entry-verification">
          <summary>How bio verification works</summary>
          <ol>
            <li>Preview your public profile in the same @handle card.</li>
            <li>Open Manage and sign in with your Passkey.</li>
            <li>Add your verification code to your Instagram bio, or the verification link to your profile links.</li>
            <li>Return to your card and verify. The code expires after 10 minutes.</li>
          </ol>
          <p>A preview does not give ownership. An existing card stays with its owner.</p>
        </details>
      </div>
    </section>
  );
}
